/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header";
import DetailTransaction from "./DetailTransaction";
import DetailStore from "./DetailStore";
import RatingComponent from "./RatingComponent";
import OrderSummary from "./OrderSummary";
import Tracking from "./Tracking";
import DeliveryLocation from "./DeliveryLocation";
import PaymentMethod from "./PaymentMethod";
import PaymentSummary from "./PaymentSummary";
import FooterAction from "./FooterAction";
import { getOrderDetail } from "../../../store/reducers/order";
import { getTopupDetail } from "../../../store/reducers/voucher";
import { uniqueID } from "../../../utils/constants";
import { cleanText, encodeValue, isEmptyData, sendAnalyticsCustomEvent, sendAnalyticsPageView, trackMetaPixelEvent } from "../../../utils/helper";
import useNavigation from "../../../hook/useNavigation";
import TableNumber from "../../../ufood-x/components/Outlet/TableNumber";
import Status from "../Status";

function OrderHistorydetails() {
  const dispatch = useDispatch();
  const navigate = useNavigation();

  const { orderType: paramOrderType, orderNumber: paramOrderNumber } = useParams();

  const tab = useSelector((state) => state.order?.tab);
  const customerID = useSelector((store) => store.user?.customerID);
  const user = useSelector((store) => store?.user);

  const initialOrderType = paramOrderType === "on-process" ? "all" : paramOrderType || "all";
  const initialOrderNumber = paramOrderNumber || "";

  const orderDetails = useSelector((state) => state.order?.detail);
  const topupDetail = useSelector((state) => state.voucher?.detail);
  const orderLoading = useSelector((state) => state.order?.loading);
  const topupLoading = useSelector((state) => state.voucher?.loading);

  const loading = isEmptyData(orderDetails) && isEmptyData(topupDetail);
  const fetchAttemptedRef = useRef(false);
  const orderType = cleanText(orderDetails?.orderType)

  const handleGetOrderDetail = async () => {
    try {
      dispatch(getOrderDetail({ 
        unquieid: uniqueID, 
        customerID: encodeValue(customerID),
        orderNumber: paramOrderNumber }
      ))
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    tab === "pesanan" ?
      dispatch(getOrderDetail({ 
        unquieid: uniqueID, 
        customerID: encodeValue(customerID),
        orderNumber: paramOrderNumber }
      )) :
      dispatch(getTopupDetail(paramOrderNumber));
  }, []);

  useEffect(() => {
    if(tab === "pesanan") {
      sendAnalyticsPageView("detail_order_session");
    }
    if(topupDetail && tab === "topup") {
      const params = {
        topup_id: topupDetail?.topup_id,
        payment_method: topupDetail?.payment_method,
        amount: topupDetail?.topup_nominal,
      }
      sendAnalyticsCustomEvent("detail_topup_session", params);
      trackMetaPixelEvent('detail_topup_session', params);
    }
  }, []);

  useEffect(() => {
    if(orderDetails && tab === "pesanan") {
      sendAnalyticsCustomEvent("history_detail_order", orderDetails); 
    }

    if(topupDetail && tab === "topup") {
      sendAnalyticsCustomEvent('history_topup_detail', topupDetail);
      trackMetaPixelEvent('history_topup_detail', topupDetail);
    }
  }, []);

  const fetchLoading = tab === "pesanan" ? orderLoading : topupLoading;
  const fetchDetail = tab === "pesanan" ? orderDetails : topupDetail;

  useEffect(() => {
    if (fetchLoading) {
      fetchAttemptedRef.current = true;
    } else if (fetchAttemptedRef.current && isEmptyData(fetchDetail)) {
      navigate.push("/not-found");
    }
  }, [fetchLoading, fetchDetail, tab]);

  useEffect(() => {
    if (initialOrderNumber === "") {
      navigate.push("/history");
    } else {
      getOrderDetail();
    }
  }, [initialOrderNumber, dispatch, customerID]);

  useEffect(() => {
    if (!loading && !orderDetails && !topupDetail) {
      navigate.push("/history");
    }
  }, [loading, orderDetails]);

  return (
    <div className="main-div transaction-details overflow-x-hidden">
      <Header initialOrderType={initialOrderType} />
      {loading ? (
        <div className="content-body rel history-detail">
          <div className="container">
            <div className="voucher-list on-process-list">
              <ul>
                <li>
                  <ContentLoader viewBox="0 0 380 70">
                    <rect x="0" y="0" rx="5" ry="5" width="70" height="70" />
                    <rect x="80" y="17" rx="4" ry="4" width="300" height="13" />
                    <rect x="80" y="40" rx="3" ry="3" width="250" height="10" />
                  </ContentLoader>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="content-body rel history-detail">
          <DetailTransaction orderDetails={tab === "pesanan" ? orderDetails : topupDetail} />
          {tab === "pesanan" && <DetailStore orderDetails={orderDetails} />}
          {(tab === "pesanan" && orderType != 'delivery' && user?.is_b2b) && <TableNumber tableNumber={orderDetails?.order_table_number} orderType={orderType} />}
          {tab === "pesanan" && orderDetails?.orderStatus === "4" && (
            <div className="px-4">
              <RatingComponent order={orderDetails}/>
            </div>
          )}
          <OrderSummary orderDetails={tab === "pesanan" ? orderDetails : topupDetail} />
          <Status />
          {/* {tab === "pesanan" && orderType === 'delivery' && ["1", "2", "3"].includes(orderDetails?.orderStatus) && (
            <div className="px-4">
              <Tracking orderDetails={orderDetails} />
            </div>
          )} */}
          {tab === "pesanan" && <DeliveryLocation orderDetails={orderDetails} />}
          <PaymentMethod orderDetails={tab === "pesanan" ? orderDetails : topupDetail} />
          <PaymentSummary orderDetails={tab === "pesanan" ? orderDetails : topupDetail} />
          <FooterAction orderDetails={orderDetails} handleGetOrderDetail={handleGetOrderDetail} />
        </div>
      )}
    </div>
  );
}

export default OrderHistorydetails;
